<template>
  <div
    ref="sdOverlay"
    class="sd-overlay"
  >
    <slot />
  </div>
</template>

<script>
import Overlay from 'ol/Overlay.js'
export default {
  name: 'SdOverlay2',
  props: {
    map: {
      type: Object,
      default() {
        return null
      }
    },
    coordinate: {
      type: Array,
      default() {
        return null
      }
    },
    props: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      overlay_: null,
      props_: {}
    }
  },

  watch: {
    map(val) {
      this.initMap(val)
    },
    coordinate(val) {
      if (this.overlay_) {
        this.setPosition(val)
      }
    }
  },
  mounted() {
    this.initMap(this.map)
  },
  destroyed() {
    this.unMap()
  },
  methods: {
    initMap(map) {
      if (!map) {
        return
      }
      this.props_ = Object.assign(this.props, { element: this.$refs.sdOverlay, })
      this.overlay_ = new Overlay(this.props_)
      if (this.coordinate) {
        this.setPosition(this.coordinate)
      }
      this.map.addOverlay(this.overlay_)
    },
    unMap() {
      this.map?.removeOverlay(this.overlay_)
    },
    setPosition(position) {
      this.overlay_?.setPosition(position)
    }
  }
}
</script>

<style scoped>
.sd-overlay {
  z-index: 100;
}
</style>
